module.exports = __webpack_public_path__ + "img/location.4566eab8.png";